export default "__VITE_ASSET__7069c8d6__"